import {  Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import {  RouterOutlet } from '@angular/router';
import { ThemeService } from './services/theme.service';
import { MaterialModule } from '../material.module';
import { ThemePickerComponent } from './theme-picker/theme-picker.component';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet,MaterialModule,ThemePickerComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {

  currentThemeSetting: string = 'light';
  constructor(private themeService : ThemeService) { }
  
  ngOnInit(): void {
    const localStorageTheme = localStorage.getItem('theme');
    this.currentThemeSetting = this.themeService.calculateSettingAsThemeString(localStorageTheme);
    this.themeService.updateThemeOnHtmlEl(this.currentThemeSetting);
  }

switchTheme(theme: 'light-theme' | 'dark-theme') {
    document.body.classList.remove('light-theme', 'dark-theme');
    document.body.classList.add(theme);
  }

}
